import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from './Dropdown';
import Icon from "@icon/Icon";
/**
 * @export
 * Displays a small circular info icon (ⓘ) that opens a popup on click.
 * Supports plain text, a list of strings, or any ReactNode as content.
 * Popup content is constrained to a max width of 25rem and max height of 10rem with scroll.
 *
 * @example
 * ```tsx
 * // Plain text
 * <InfoButton content="This field is required." />
 * ```
 *
 * @example
 * ```tsx
 * // List of strings
 * <InfoButton content={["Must be at least 8 characters", "No spaces allowed"]} position="bottom-left" />
 * ```
 *
 * @example
 * ```tsx
 * // ReactNode
 * <InfoButton content={<span>See <a href="#">docs</a> for details</span>} />
 * ```
 *
 * @category Overlays
 */
const InfoButton = ({ content, position = "top-right", size = 'default' }) => {
    const renderContent = () => {
        if (Array.isArray(content)) {
            return (_jsx("div", { className: "uxpcore_info-button__content", children: _jsx("ul", { className: "uxpcore_info-button__list", children: content.map((item, i) => _jsx("li", { children: item }, i)) }) }));
        }
        return _jsx("div", { className: "uxpcore_info-button__content", children: content });
    };
    const btnClass = size === 'small'
        ? 'uxpcore_info-button__btn uxpcore_info-button__btn--small'
        : 'uxpcore_info-button__btn';
    return (_jsx(Dropdown, { position: position, trigger: _jsx("div", { className: btnClass, children: _jsx(Icon, { icon: ['fas', 'info-circle'] }) }), content: renderContent() }));
};
export default InfoButton;
